import React from 'react';
import { Flex, Text } from '@leverege/ui-elements';
import S from './SaleError.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SaleError(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: S.container,
    children: [/*#__PURE__*/_jsx("img", {
      className: S.locatorError,
      src: "https://recovr-ui-assets.storage.googleapis.com/sale-unsuccessful.png",
      alt: "Sale unsuccessful",
      height: 120,
      width: 120
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "colLCenter",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "screenTitle",
        children: "Sale Unsuccessful"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "bodyCentered",
        children: "Uh Oh! Looks like we've encountered an error. Please try again."
      })]
    })]
  });
}